import compact from 'lodash/compact';
import { AddressDTO } from 'artifacts/dtos';
import { getAddressString } from 'utils/helper';

export function autosuggestHighlightParse(text: string, matches: [number, number][]) {
  const result = [];
  let lastEnd = 0;

  matches.forEach(([start, end]) => {
    if (start > lastEnd) {
      result.push({ text: text.slice(lastEnd, start), highlight: false });
    }
    result.push({ text: text.slice(start, end), highlight: true });
    lastEnd = end;
  });

  if (lastEnd < text.length) {
    result.push({ text: text.slice(lastEnd), highlight: false });
  }

  return matches.length === 0 ? [{ text, highlight: false }] : result;
}

export function formatPlace(value: AddressDTO) {
  return {
    place: {
      description: getAddressString(value),
      structured_formatting:
        {
          main_text: value.street ?? '',
          secondary_text: compact([value.city, value.state, value.country]).join(' '),
          main_text_matched_substrings: [],
        },
    },
  };
}
